import { Pipe, PipeTransform } from '@angular/core';
import { FundType } from '../../../models/transactions/fund-type';

@Pipe({
  name: 'fundTypeById'
})
export class FundTypeByIdPipe implements PipeTransform {
  transform(fundTypeId: number, fundTypes: FundType[] | null): FundType | undefined {
    if (!fundTypes) return undefined;
    const fundType = fundTypes.find(ft => ft.id === fundTypeId);
    return fundType ? fundType : undefined;
  }
}
